import ApplicationDefaults from "@wielink-application/shared/js/mixins/applicationDefaults.js";
export default ApplicationDefaults;
